import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import cn from 'classnames';
import FormattedInput, { IFormattedInput } from '../FormattedInput/FormattedInput';
import { IFormikTextField } from './FormikTextField';
import { TextFieldProps } from '../TextField/TextField';

type IFormikFormattedTextFieldProps = TextFieldProps & IFormattedInput & IFormikTextField;

const FormikFormattedTextField: React.FC<IFormikFormattedTextFieldProps> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const classes = useStyles();
  const {
    valueId,
    className,
    formik: { values, errors, handleChange, touched, handleBlur },
    ...other
  } = props;
  return (
    <FormattedInput
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      data-testid="formik-formatted-text-field__digits-input"
      name={valueId}
      className={cn(classes.root, className)}
      value={values[valueId]}
      onChange={handleChange}
      error={!!errors[valueId] && !!touched[valueId]}
      helperText={errors[valueId] && touched[valueId] ? errors[valueId] : null}
      onBlur={handleBlur}
      variant="outlined"
      FormHelperTextProps={{ className: classes.helper }}
    />
  );
};

export default FormikFormattedTextField;

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    '& .MuiInputLabel-formControl': {
      position: 'unset',
      transform: 'unset',
      marginBottom: '0.5em',
    },
    '& .MuiOutlinedInput-root': {
      '& legend span': {
        display: 'none',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '0.8em 1em',
    },
  },
  helper: {
    margin: theme.spacing(1, 0, 0),
    lineHeight: 1.1,
  },
}));
